import {
  logoutUser,
  authRenew,
} from 'store/actions/loginActions';
import {
  take,
  put,
  cancel,
  fork,
  delay,
} from 'redux-saga/effects';

const TIMEOUT_PERIOD_MILLISECONDS = 2 * 60 * 60 * 1000; // 2 hours
const RENEW_PERIOD_MILLISECONDS = 10 * 60 * 1000; // 10 minutes

let lastActivity = 0;

function* waitAndRenewToken() {
  while (true) {
    yield delay(RENEW_PERIOD_MILLISECONDS);

    const token = localStorage.getItem('auth');
    if (token) {
      if (!lastActivity || Date.now() - lastActivity < RENEW_PERIOD_MILLISECONDS) {
        const authTime = localStorage.getItem('authTime');
        let timeSince = 0;
        if (authTime) {
          timeSince = Date.now() - parseInt(authTime, 10);
        }
        if (!timeSince || timeSince > (RENEW_PERIOD_MILLISECONDS / 2)) {
          yield put(authRenew(token));
        }
      }
    }
  }
}

function* waitAndSignOutUser() {
  let timeoutPeriod = TIMEOUT_PERIOD_MILLISECONDS;
  while (true) {
    yield delay(timeoutPeriod);

    const authTime = localStorage.getItem('authTime');
    let timeSince = 0;
    if (authTime) {
      timeSince = Date.now() - parseInt(authTime, 10);
    }

    if (!timeSince || timeSince >= TIMEOUT_PERIOD_MILLISECONDS) {
      yield put(logoutUser());
      return;
    }

    if (timeSince) {
      timeoutPeriod = TIMEOUT_PERIOD_MILLISECONDS - timeSince;
    } else {
      timeoutPeriod = TIMEOUT_PERIOD_MILLISECONDS;
    }
  }
}

function* activityWatchLoop() {
  while (true) {
    const signOutTask = yield fork(waitAndSignOutUser);
    yield take((action) => action && action.type && !action.automated && !action.response);
    lastActivity = Date.now();
    yield cancel(signOutTask);
  }
}

export const autoSignOutSaga = [
  fork(activityWatchLoop),
  fork(waitAndRenewToken),
];